import type { PrintAlignment } from '#shared/types';

/** One list for every alignment picker in the template builder, in reading order. */
export const ALIGNMENT_OPTIONS = [
  { value: 'left', label: 'Left' },
  { value: 'center', label: 'Centre' },
  { value: 'right', label: 'Right' },
] as const satisfies readonly { value: PrintAlignment; label: string }[];
